module.exports = __webpack_public_path__ + "static/media/gsw-logo.004510f9.png";